import React from 'react'

import { ControllerRenderProps } from 'react-hook-form'
import TextareaAutosize from 'react-textarea-autosize'

import { ApplicationE, ApplicationFormFieldsT } from 'data/application'
import { getStyles, styled, theme } from 'ui/styles'

const Input = styled(TextareaAutosize)<{ isValid: boolean; isNotEmpty: boolean }>`
  display: flex;
  ${getStyles('t5')}
  align-self: start;
  border-radius: 8px;
  border: 1px solid
    ${({ isValid, isNotEmpty }) =>
      isValid ? (isNotEmpty ? theme.palette.primary : theme.palette.coldGrey) : theme.palette.red};
  width: 100%;
  padding: 8px 16px;
  color: ${theme.palette.primary};

  transition-property: color, border, box-shadow;
  transition-duration: ${theme.transition.hover}ms;

  &::placeholder {
    color: ${theme.palette.coldGrey};
  }

  @media (hover: hover) {
    &:hover {
      border: 1px solid white;
      box-shadow: 0 0 0px 1px ${theme.palette.blue}, 0px 4px 5px rgba(0, 0, 0, 0.15);
    }

    &:focus,
    &:active,
    &:target {
      border: 1px solid ${theme.palette.blue};
    }
  }

  &:focus,
  &:active,
  &:target {
    border: 1px solid ${theme.palette.blue};
    box-shadow: 0px 4px 5px rgba(20, 31, 62, 0.2);
  }
`

type Props = {
  value: string
  isValid: boolean
  isBig?: boolean
  placeholder?: string
  field: ControllerRenderProps<ApplicationFormFieldsT, ApplicationE>
}

export const Textarea: React.FC<Props> = ({ value, placeholder, isValid, isBig, field }) => {
  const isNotEmpty = Boolean(value)

  return (
    <Input
      isValid={isValid}
      minRows={isBig ? 4 : 1}
      maxRows={8}
      rows={isBig ? 4 : 1}
      placeholder={placeholder}
      isNotEmpty={isNotEmpty}
      {...field}
    />
  )
}
